export default __webpack_public_path__ + "static/media/awards-gold-prize.56830081.png";